<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M35.1311 18.1626C35.1311 27.5515 27.5199 35.1626 18.1311 35.1626C8.74226 35.1626 1.1311 27.5515 1.1311 18.1626C1.1311 8.77381 8.74226 1.16265 18.1311 1.16265C27.5199 1.16265 35.1311 8.77381 35.1311 18.1626Z" stroke="black"/>
    <line x1="9.94183" y1="18.3164" x2="15.4222" y2="25.4132" stroke="black" stroke-width="4"/>
    <line x1="12.8027" y1="25.1028" x2="27.2522" y2="13.619" stroke="black" stroke-width="4"/>
  </svg>
</template>